import { render } from "./Lowbar.vue?vue&type=template&id=1547bd52"
import script from "./Lowbar.vue?vue&type=script&lang=ts"
export * from "./Lowbar.vue?vue&type=script&lang=ts"
script.render = render

export default script